import { render, staticRenderFns } from "./ReportsMain.vue?vue&type=template&id=7f446994&scoped=true&"
import script from "./ReportsMain.vue?vue&type=script&lang=js&"
export * from "./ReportsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f446994",
  null
  
)

export default component.exports